import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { HelpComponent } from './help.component';

@NgModule({
  declarations: [HelpComponent],
  imports: [SharedModule],
  exports: [HelpComponent],
})
export class HelpModule {}
